const getSeasonalLogo = (now = new Date()) => {
    const currentDate = now
    const currentYear = currentDate.getFullYear()
    const currentMonth = currentDate.getMonth()
    const currentDay = currentDate.getDate()

    // Christmas season: Dec 1 - Dec 26 (inclusive)
    if (currentMonth === 11 && currentDay >= 1 && currentDay <= 26) {
        return 'christmas'
    }

    // Valentine's season: Jan 15 - Feb 15 (inclusive)
    const startOfValentines = new Date(currentYear, 0, 15)
    const endOfValentines = new Date(currentYear, 1, 16)
    if (currentDate >= startOfValentines && currentDate < endOfValentines) {
        return 'valentines'
    }

    // Mother's Day season: Apr 6 - May 11 (inclusive)
    const startOfMothersDay = new Date(currentYear, 3, 6)
    const endOfMothersDay = new Date(currentYear, 4, 12)
    if (currentDate >= startOfMothersDay && currentDate < endOfMothersDay) {
        return 'mothers'
    }

    return 'default'
}
export default getSeasonalLogo
